import { Component } from '@angular/core';
import { catchError, finalize, forkJoin, map, of, switchMap } from 'rxjs';
import { ToasterService } from '../../../../providers/toaster/toaster.service';
import { ConfomerService } from '../../../../providers/confomer/confomer.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CommonStaffApiServiceService } from '../../common-staff-api-service.service';
import { StaffCommonFormModalComponent } from "../../../../components/personnel-component/staff-common-form-modal/staff-common-form-modal.component";
import { PaginationComponent } from "../../../../components/pagination/pagination.component";
import debounce from 'lodash/debounce';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from "../../../../providers/loader.component";
import { FilterBaseAccessService } from '../../../../auth/filterbase-access';
import { exportToCsv, exportToExcel, exportToPdf, parseCsvToObjects, type ExportColumn } from '../../utils/personnel-import-export';

@Component({
  selector: 'app-hod-list',
  standalone: true,
  imports: [RouterModule, CommonModule, StaffCommonFormModalComponent, PaginationComponent, FormsModule, LoaderComponent],
  templateUrl: './hod-list.component.html',
  styleUrl: './hod-list.component.css'
})
export class HodListComponent {

  hod_import_export = false;
  create_hod = false; 
  view_hod = false;
  list_hod = false;
  edit_hod = false;
  delete_hod = false;
  
  formType: 'new' | 'edit' = 'new'
  hodId: number | string | null = null
  isMoaldalOpen = false
  hodList: any[] = []

  paginationData: any = {}
  currentPage: any = 1

  searchStr: string = '';
  isFetching: boolean = false;
  private readonly exportColumns: ExportColumn[] = [
    { key: 'name', label: 'Name' },
    { key: 'mobile', label: 'Mobile' },
    { key: 'email', label: 'Email' },
    { key: 'department', label: 'Department' }
  ];
  constructor(access:FilterBaseAccessService ,private staffApiService: CommonStaffApiServiceService, private toasterService: ToasterService, private conformer: ConfomerService,) {

    this.hod_import_export = access.checkaccessforfiltersandactions('hod import export');
    this.create_hod = access.checkaccessforfiltersandactions('create hod');
    this.view_hod = access.checkaccessforfiltersandactions('view hod');
    this.list_hod = access.checkaccessforfiltersandactions('hod list');
    this.edit_hod = access.checkaccessforfiltersandactions('edit hod');
    this.delete_hod = access.checkaccessforfiltersandactions('delete hod');
  }

  ngOnInit() {
    this.getData()
  }

  getData() {
    this.isFetching = true;
    this.staffApiService.getStaffList('HOD', this.currentPage, this.searchStr)

    .pipe(
      finalize(() => {
        this.isFetching = false;
      })
    )
    .subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          this.hodList = res?.data?? [];
          this.paginationData = res?.pagination ?? {};
        } else {
          this.toasterService.setToaster('error', 'Error', res.message ?? 'Failed to fetch HOD list');
          this.hodList = [];
        }

      },
      error: (err) => {
        console.error('HTTP error:', err);
      }
    })
  }

  search = debounce(() => {
    this.getData();
    return;
  }, 500);

  async deletehod(id: any) {
    if (!id) {
      return
    }

    const confirmer = await this.conformer.Open('Delete Student Profile!', 'Are you sure you want to delete this student profile')
    if (confirmer) {
      this.staffApiService.deleteStaff(id).pipe(
        finalize(() => {
          this.getData()
        })
      ).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.toasterService.setToaster('success', 'Success', res.message ?? 'Student deleted successfully');
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
        }
      })
    }

  }



  showHodFormModal(type: 'new' | 'edit', hodId?: number | string | null) {
    console.log("Showed Modal Open")
    this.formType = type
    this.hodId = hodId || null
    setTimeout(() => {
      this.isMoaldalOpen = true;
    }, 100);
  }

  emitedData(data: any) {
    console.log(data)
    this.isMoaldalOpen = false;
    this.hodId = null;
    this.formType = 'new';
    this.getData();
  }

  pageChange(e: any) {
    this.currentPage = e;
    this.getData();
  }

  private loadHodExportRows(roleId: number | string, search?: string) {
    return this.staffApiService.getStaffList(roleId, 1, search).pipe(

      switchMap((res: any) => {
        const rows = Array.isArray(res?.data) ? res.data : [];
        const pagination = res?.pagination ?? {};
        const lastPage = Number(pagination?.last_page ?? 0) || ((Number(pagination?.total ?? 0) > 0 && Number(pagination?.per_page ?? 0) > 0)
          ? Math.ceil(Number(pagination.total) / Number(pagination.per_page))
          : 0);
        if (lastPage <= 1) {
          return of(rows);
        }
        const pageRequests = [];
        for (let page = 2; page <= lastPage; page += 1) {
          pageRequests.push(
            this.staffApiService.getStaffList(roleId, page, search).pipe(
              map((pageRes: any) => Array.isArray(pageRes?.data) ? pageRes.data : []),
              catchError(() => of([]))
            )
          );
        }
        return forkJoin(pageRequests).pipe(
          map((pages: any[]) => rows.concat(...pages))
        );
      })
    );
  }

  exportData(type: 'csv' | 'excel' | 'pdf') {
    this.loadHodExportRows('HOD', this.searchStr || undefined).subscribe((rows: any[]) => {

      if (!rows?.length) {
        this.toasterService.setToaster('error', 'Export', 'No HOD data available to export.');
        return;
      }
      const filenameBase = 'hod-list';
      if (type === 'pdf') {
        exportToPdf(rows, this.exportColumns, 'HOD List');
        return;
      }
      if (type === 'excel') {
        exportToExcel(rows, this.exportColumns, `${filenameBase}.xls`);
        return;
      }
      exportToCsv(rows, this.exportColumns, `${filenameBase}.csv`);
    });
  }

  handleImportFile(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const rows = parseCsvToObjects(String(reader.result ?? ''));
      if (!rows.length) {
        this.toasterService.setToaster('error', 'Import', 'No valid rows found in CSV.');
        return;
      }
      const requests = rows.map(row => {
        const payload = { ...row, role: 'HOD', role_id: 'HOD' };
        return this.staffApiService.createStaffProfile(payload).pipe(
          map(() => ({ ok: true })),
          catchError(() => of({ ok: false }))
        );
      });
      forkJoin(requests).subscribe(results => {
        const successCount = results.filter(result => result.ok).length;
        const failedCount = results.length - successCount;
        if (successCount) {
          this.getData();
        }
        if (failedCount) {
          this.toasterService.setToaster('warning', 'Import', `${successCount} imported, ${failedCount} failed.`);
        } else {
          this.toasterService.setToaster('success', 'Import', `${successCount} HODs imported successfully.`);
        }
      });
    };
    reader.readAsText(file);
    input.value = '';
  }

}
